<template>
  <div class="telegram-bot-pending">
    <p class="telegram-bot-pending__description">
      Відскануйте QR-код камерою телефону або скопіюйте посилання, а потім натисніть «Start» у боті —
      акаунт привʼяжеться автоматично.
    </p>

    <div class="telegram-bot-pending__qr" v-if="qrCode">
      <img :src="qrCode" alt="QR-код для привʼязки Telegram-бота" />
    </div>

    <CopyInput class="telegram-bot-pending__link" :value="link" :is-disabled="!link" />

    <p class="telegram-bot-pending__hint">Посилання дійсне 15 хвилин. Очікуємо підтвердження…</p>
  </div>
</template>

<script>
import { CopyInput } from '@/shared/ui/form';

export default {
  components: { CopyInput },
  props: {
    link: {
      type: String,
      default: null,
    },
    qrCode: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.telegram-bot-pending {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 380px;
  margin: 0 auto;

  &__description {
    font-size: 14px;
    color: #71717A;
    margin-bottom: 24px;
  }

  &__qr {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border: 1px solid #E4E4E7;
    border-radius: 6px;
    width: 220px;
    height: 220px;
    margin-bottom: 24px;

    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  &__link {
    margin-bottom: 16px;
  }

  &__hint {
    font-size: 14px;
    color: #71717A;
  }
}
</style>
